import { STAFF_ROLES } from '../staff/staff-enums';
/**
 * PERSONEL YETKİ KATALOĞU — ÜRÜNÜN `PERMISSIONS` KATALOĞUNDAN AYRI
 * (panel kimliği ayrımı · Karar 3d).
 *
 * NEDEN AYRI KATALOG: bugünkü ayrım TÜRETİLMİŞ bir olguydu
 * (`requiresPanelSession(required)` bir dize kümesine bakıyordu) ve doğru
 * düzenlenmesine bağlıydı. Ayrı katalogda hata YAPISALDIR: personel anahtarı
 * ürün rolüne verilemez, çünkü ürün rol tablosu bu tipi hiç tanımaz.
 *
 * Anahtar ön eki `staff:` — bir yetkiyi yanlış katalogda kullanmak derleme
 * hatasıdır, çalışma zamanı sürprizi değil.
 *
 * BU MODÜL `@icebreaker/shared/staff` ALT YOLUNDAN ÇIKAR ve kök barrel'a
 * KONMAZ: `apps/web` ve `apps/mobile` personel yetki adlarını hiç görmemelidir
 * (import sayısı = 0, `staff-surface-separation.guard.spec` ölçer).
 */
export const STAFF_PERMISSIONS = {
    /** Denetim defterini okuma (eski `admin:audit_read`). */
    AUDIT_READ: 'staff:audit_read',
    /** Moderasyon kuyruğu ve kararları (eski `admin:moderate`). */
    MODERATE: 'staff:moderate',
    /** Sahiplenme talebi kararı (eski `claim:decide`). */
    CLAIM_DECIDE: 'staff:claim_decide',
    /** Kurum doğrulama kararı (eski `organization:verification_decide`). */
    ORGANIZATION_VERIFICATION_DECIDE: 'staff:organization_verification_decide',
    /**
     * Personel hesabı açma / davet etme / askıya alma. Panelde "şifremi unuttum"
     * OLMADIĞI için kurtarma yolu budur ve YALNIZ `admin` taşır — bir insan
     * kararı, posta kutusuna EK bir faktördür (Karar 4c).
     */
    ACCOUNT_MANAGE: 'staff:account_manage',
    /**
     * Kurumu panelden DOĞRULANMIŞ açma ve sahip davetini yönetme (kurum satışla
     * açılır · Story C1, V3). Kurum kimliği üretir ve deneme kredisi yazar: para
     * izi ve kişisel veri, yalnız `admin` taşır.
     */
    ORGANIZATION_PROVISION: 'staff:organization_provision',
    /**
     * Kredi yükleme, ters kayıt, Kurumsal sözleşme tanımlama/sonlandırma ve
     * kredi defterini okuma (kurum satışla açılır · Story D5, V3). Para izidir:
     * yalnız `admin` taşır.
     */
    CREDIT_MANAGE: 'staff:credit_manage',
    /**
     * Satış adaylarını listeleme, detayını görme ve durumunu değiştirme
     * (Story B4, V3). Detay kişisel veriye erişimdir, her görüntüleme denetim
     * defterine yazılır. Yalnız `admin` taşır.
     */
    SALES_INQUIRY_MANAGE: 'staff:sales_inquiry_manage',
    /**
     * Kurumun herkese açık kapak görselini panelden gerekçeyle kaldırma (kurum
     * kapağı · Story P1, 14.10.2026). Kurum detayındaki ayrı bir eylemdir: kurum
     * ekranını görmek (`organization_provision`) kaldırmaya yetmez. Yalnız `admin`
     * taşır; `moderator` kurum ekranını hiç görmediği için ona verilmez.
     */
    ORGANIZATION_COVER_REMOVE: 'staff:organization_cover_remove',
    /** Kendi oturum listesini okuma. */
    SELF_SESSION_READ: 'staff:self_session_read',
    /** Kendi oturumunu sonlandırma. */
    SELF_SESSION_REVOKE: 'staff:self_session_revoke',
    /** Kendi şifresini değiştirme (eski `panel:password_manage`). */
    SELF_PASSWORD_MANAGE: 'staff:self_password_manage',
    /** Kendi kimlik/durum bilgisini okuma (panel kabuğu bunu bekler). */
    SELF_READ: 'staff:self_read',
};
/**
 * Her personelin — rolü ne olursa olsun — taşıdığı taban yetkiler.
 * KENDİ hesabına dair haklardır; başkasının verisine hiçbiri dokunmaz.
 */
const STAFF_BASE_PERMISSIONS = [
    STAFF_PERMISSIONS.SELF_READ,
    STAFF_PERMISSIONS.SELF_SESSION_READ,
    STAFF_PERMISSIONS.SELF_SESSION_REVOKE,
    STAFF_PERMISSIONS.SELF_PASSWORD_MANAGE,
];
/**
 * Rol → yetki. `admin` KATALOĞUN TAMAMINI DEĞİL, açıkça sayılan kümeyi taşır.
 *
 * NEDEN `Object.values(...)` DEĞİL: ürün tarafında `admin` rolü tam da böyle
 * tanımlıydı ve sonucu şuydu — "admin'in taşıdığı yetki" ölçütü her şeyi
 * kapsadığı için hiçbir şeyi ayırt etmiyordu. Açık liste, yeni bir anahtar
 * eklendiğinde "bunu admin de mi taşısın" sorusunu ZORUNLU kılar.
 */
export const STAFF_ROLE_PERMISSIONS = {
    admin: [
        ...STAFF_BASE_PERMISSIONS,
        STAFF_PERMISSIONS.AUDIT_READ,
        STAFF_PERMISSIONS.MODERATE,
        STAFF_PERMISSIONS.CLAIM_DECIDE,
        STAFF_PERMISSIONS.ORGANIZATION_VERIFICATION_DECIDE,
        STAFF_PERMISSIONS.ACCOUNT_MANAGE,
        STAFF_PERMISSIONS.ORGANIZATION_PROVISION,
        STAFF_PERMISSIONS.CREDIT_MANAGE,
        STAFF_PERMISSIONS.SALES_INQUIRY_MANAGE,
        STAFF_PERMISSIONS.ORGANIZATION_COVER_REMOVE,
    ],
    moderator: [...STAFF_BASE_PERMISSIONS, STAFF_PERMISSIONS.MODERATE],
};
/** Rolün yetkisi — bilinmeyen rol boş küme alır (fail-closed). */
export function staffPermissionsForRole(role) {
    if (!role)
        return [];
    return STAFF_ROLE_PERMISSIONS[role] ?? [];
}
/** Katalogdaki her anahtar en az bir role verilmiş mi (ölü anahtar kapısı). */
export const STAFF_PERMISSION_VALUES = Object.values(STAFF_PERMISSIONS);
export { STAFF_ROLES };
//# sourceMappingURL=staff-permissions.js.map